import { getEmailFromVideoAccess } from './funnelTracking';
import { getOrCreateAnonymousId } from './anonymousId';
import { getAttributionPayload } from './attribution';

/**
 * Registra la visita en la pestaña "Visitas" del Sheet.
 *
 * Vivía suelta dentro de HomePage, así que la home era la ÚNICA página medida.
 * El 2026-08-08 salió a la luz el agujero: los correos mandan el tráfico a
 * /form, y esas llegadas no quedaban registradas en ninguna parte. Con el
 * newsletter apuntando ahí, decidir si el correo trae gente era adivinar.
 *
 * Nunca revienta la página: si el backend no responde, la visita se pierde y
 * el usuario ni se entera.
 */
export const trackVisit = async () => {
  try {
    const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const attribution = getAttributionPayload();
    await fetch(`${backendUrl}/api/track-visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: window.location.pathname,
        referrer: attribution.referrer || document.referrer || 'direct',
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        language: navigator.language || 'unknown',
        email: getEmailFromVideoAccess() || undefined,
        anonymous_id: getOrCreateAnonymousId(),
        utm_source: attribution.utm_source || undefined,
        utm_medium: attribution.utm_medium || undefined,
        utm_campaign: attribution.utm_campaign || undefined,
        utm_content: attribution.utm_content || undefined,
        utm_term: attribution.utm_term || undefined,
        gclid: attribution.gclid || undefined,
        fbclid: attribution.fbclid || undefined,
        landing_page: attribution.landing_page || undefined,
      }),
    });
  } catch (_) {}
};

export default trackVisit;
